import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ContentAssetReferenceDeleteMutationMutationVariables = Types.Exact<{
  contentAssetReference: Types.ContentAssetReferenceDeleteInput
}>

export type ContentAssetReferenceDeleteMutationMutation = {
  __typename?: 'Mutation'
  contentAssetReferenceDelete: {
    __typename?: 'ContentAssetReferenceMutationResponse'
    success: boolean
  }
}

export const ContentAssetReferenceDeleteMutationDocument = gql`
  mutation ContentAssetReferenceDeleteMutation(
    $contentAssetReference: ContentAssetReferenceDeleteInput!
  ) {
    contentAssetReferenceDelete(contentAssetReference: $contentAssetReference) {
      success
    }
  }
`
export type ContentAssetReferenceDeleteMutationMutationFn = Apollo.MutationFunction<
  ContentAssetReferenceDeleteMutationMutation,
  ContentAssetReferenceDeleteMutationMutationVariables
>

/**
 * __useContentAssetReferenceDeleteMutationMutation__
 *
 * To run a mutation, you first call `useContentAssetReferenceDeleteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentAssetReferenceDeleteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentAssetReferenceDeleteMutationMutation, { data, loading, error }] = useContentAssetReferenceDeleteMutationMutation({
 *   variables: {
 *      contentAssetReference: // value for 'contentAssetReference'
 *   },
 * });
 */
export function useContentAssetReferenceDeleteMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContentAssetReferenceDeleteMutationMutation,
    ContentAssetReferenceDeleteMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContentAssetReferenceDeleteMutationMutation,
    ContentAssetReferenceDeleteMutationMutationVariables
  >(ContentAssetReferenceDeleteMutationDocument, options)
}
export type ContentAssetReferenceDeleteMutationMutationHookResult = ReturnType<
  typeof useContentAssetReferenceDeleteMutationMutation
>
export type ContentAssetReferenceDeleteMutationMutationResult =
  Apollo.MutationResult<ContentAssetReferenceDeleteMutationMutation>
export type ContentAssetReferenceDeleteMutationMutationOptions = Apollo.BaseMutationOptions<
  ContentAssetReferenceDeleteMutationMutation,
  ContentAssetReferenceDeleteMutationMutationVariables
>
